import { handle498OnClient } from "Helpers/is498";
import env from "Consts/env";
import { apiSlice } from "../api/apiSlice";

export const promoApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getListPromoBrowse: builder.query({
			query: (params) => ({
				url: "/api/fds-cart/promo/browse",
				headers: {
					...env.HEADERS,
				},
				params: {
					...params,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return {
					status: response?.status ?? response.meta.code,
					data: response.data,
					selected_data: response.selected_data,
				};

			},
			providesTags: ["Promo"],
		}),
		applyPromoWith498: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/coupons/${body.item}`,
				method: "PUT",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return { status: response?.status ?? response.meta.code, data: response.data };

			},
			invalidatesTags: ["Promo"],
		}),
		deletePromoWith498: builder.mutation({
			query: (body) => ({
				url: `/api/fds-cart/coupons/${body.item}`,
				method: "DELETE",
				body,
				headers: {
					...env.HEADERS,
				},
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return { status: response?.status ?? response.meta.code, data: response.data };

			},
			invalidatesTags: ["Promo"],
		}),
	}),
});

export const {
	useGetListPromoBrowseQuery,
	useApplyPromoWith498Mutation,
	useDeletePromoWith498Mutation,
} = promoApiSlice;
